module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp2_3.936477c2.png";